import { apiGet, apiPatch } from './index'
// 获取系统消息
const getSystemMessage = (params) => apiGet('/api/system/messages', params)
// 系统消息已读
const MessageStateUp = (params) => apiPatch('/api/system/messages/read', params)
// 获取未读消息
export {
  getSystemMessage,
  MessageStateUp,
}



// WEBPACK FOOTER //
// ./src/api/systemMessage.js